import { render } from "./AboutMe.vue?vue&type=template&id=46ff0886&scoped=true"
import script from "./AboutMe.vue?vue&type=script&lang=js"
export * from "./AboutMe.vue?vue&type=script&lang=js"

import "./AboutMe.vue?vue&type=style&index=0&id=46ff0886&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-46ff0886"

export default script